// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: dFnlUbPBUFay
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  hasVariant
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import Sidebar from "../../Sidebar"; // plasmic-import: NdFBK2CrJIH5/component
import TopBar from "../../TopBar"; // plasmic-import: 0Oim0KTDv11d/component
import PaymentsListCard from "../../PaymentsListCard"; // plasmic-import: 1X0CJgue1Nt5/component
import { useScreenVariants as useScreenVariantseuyRl26Gw8Ft } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: EuyRl26Gw8Ft/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicPaymentsList.module.css"; // plasmic-import: dFnlUbPBUFay/css

createPlasmicElementProxy;

export const PlasmicPaymentsList__VariantProps = new Array();

export const PlasmicPaymentsList__ArgProps = new Array();

const $$ = {};

function PlasmicPaymentsList__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantseuyRl26Gw8Ft()
  });
  return (
    <React.Fragment>
      <div
        data-plasmic-name={"root"}
        data-plasmic-override={overrides.root}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          projectcss.all,
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          projectcss.plasmic_tokens,
          plasmic_antd_5_hostless_css.plasmic_tokens,
          sty.root
        )}
      >
        <Sidebar
          data-plasmic-name={"sidebar"}
          data-plasmic-override={overrides.sidebar}
          className={classNames("__wab_instance", sty.sidebar)}
        />

        <div
          data-plasmic-name={"freeBox"}
          data-plasmic-override={overrides.freeBox}
          className={classNames(projectcss.all, sty.freeBox)}
        >
          <TopBar
            data-plasmic-name={"topBar"}
            data-plasmic-override={overrides.topBar}
            className={classNames("__wab_instance", sty.topBar)}
          />

          <Stack__
            as={"div"}
            data-plasmic-name={"figmaPaste"}
            data-plasmic-override={overrides.figmaPaste}
            hasGap={true}
            className={classNames(projectcss.all, sty.figmaPaste)}
          >
            <div
              data-plasmic-name={"title"}
              data-plasmic-override={overrides.title}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.title
              )}
            >
              {"Payments"}
            </div>
            <div
              data-plasmic-name={"searchVertStack"}
              data-plasmic-override={overrides.searchVertStack}
              className={classNames(projectcss.all, sty.searchVertStack)}
            />
          </Stack__>
          <div
            data-plasmic-name={"vertStack"}
            data-plasmic-override={overrides.vertStack}
            className={classNames(projectcss.all, sty.vertStack)}
          >
            <div
              data-plasmic-name={"figmaPaste3"}
              data-plasmic-override={overrides.figmaPaste3}
              className={classNames(projectcss.all, sty.figmaPaste3)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__nSrS
                )}
              >
                {"Amount"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__vn8BB
                )}
              >
                {hasVariant(globalVariants, "screen", "large")
                  ? "Customer"
                  : "Customer"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__h6NnR
                )}
              >
                {"Status"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__yGzZm
                )}
              >
                {"Type"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___1R58N
                )}
              >
                {"Date"}
              </div>
            </div>
            <Stack__
              as={"div"}
              data-plasmic-name={"paymentsListStack"}
              data-plasmic-override={overrides.paymentsListStack}
              hasGap={true}
              className={classNames(projectcss.all, sty.paymentsListStack)}
            >
              <PaymentsListCard
                amount={
                  hasVariant(globalVariants, "screen", "large")
                    ? "$1043.00"
                    : "$1043.00"
                }
                className={classNames(
                  "__wab_instance",
                  sty.paymentsListCard__bsYwU
                )}
                clientCompany={
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__u1PLn
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "large")
                      ? "Hello"
                      : "Hello"}
                  </div>
                }
                dateCreated={
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__d06Ca
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "large")
                      ? "Dec 28th, 2023"
                      : "Dec 28th, 12:25 AM"}
                  </div>
                }
                paymentType={"Invoice Payment"}
              />

              <PaymentsListCard
                className={classNames(
                  "__wab_instance",
                  sty.paymentsListCard__dZbiS
                )}
              />
            </Stack__>
            <div
              data-plasmic-name={"paginationStack"}
              data-plasmic-override={overrides.paginationStack}
              className={classNames(projectcss.all, sty.paginationStack)}
            >
              <div
                data-plasmic-name={"prevButton"}
                data-plasmic-override={overrides.prevButton}
                className={classNames(projectcss.all, sty.prevButton)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__rKlL
                  )}
                >
                  {"Previous"}
                </div>
              </div>
              <div
                data-plasmic-name={"nextButton"}
                data-plasmic-override={overrides.nextButton}
                className={classNames(projectcss.all, sty.nextButton)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__vDrdq
                  )}
                >
                  {"Next"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "sidebar",
    "freeBox",
    "topBar",
    "figmaPaste",
    "title",
    "searchVertStack",
    "vertStack",
    "figmaPaste3",
    "paymentsListStack",
    "paginationStack",
    "prevButton",
    "nextButton"
  ],

  sidebar: ["sidebar"],
  freeBox: [
    "freeBox",
    "topBar",
    "figmaPaste",
    "title",
    "searchVertStack",
    "vertStack",
    "figmaPaste3",
    "paymentsListStack",
    "paginationStack",
    "prevButton",
    "nextButton"
  ],

  topBar: ["topBar"],
  figmaPaste: ["figmaPaste", "title", "searchVertStack"],
  title: ["title"],
  searchVertStack: ["searchVertStack"],
  vertStack: [
    "vertStack",
    "figmaPaste3",
    "paymentsListStack",
    "paginationStack",
    "prevButton",
    "nextButton"
  ],

  figmaPaste3: ["figmaPaste3"],
  paymentsListStack: ["paymentsListStack"],
  paginationStack: ["paginationStack", "prevButton", "nextButton"],
  prevButton: ["prevButton"],
  nextButton: ["nextButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicPaymentsList__ArgProps,
          internalVariantPropNames: PlasmicPaymentsList__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicPaymentsList__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicPaymentsList";
  } else {
    func.displayName = `PlasmicPaymentsList.${nodeName}`;
  }
  return func;
}

export const PlasmicPaymentsList = Object.assign(
  // Top-level PlasmicPaymentsList renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    sidebar: makeNodeComponent("sidebar"),
    freeBox: makeNodeComponent("freeBox"),
    topBar: makeNodeComponent("topBar"),
    figmaPaste: makeNodeComponent("figmaPaste"),
    title: makeNodeComponent("title"),
    searchVertStack: makeNodeComponent("searchVertStack"),
    vertStack: makeNodeComponent("vertStack"),
    figmaPaste3: makeNodeComponent("figmaPaste3"),
    paymentsListStack: makeNodeComponent("paymentsListStack"),
    paginationStack: makeNodeComponent("paginationStack"),
    prevButton: makeNodeComponent("prevButton"),
    nextButton: makeNodeComponent("nextButton"),
    // Metadata about props expected for PlasmicPaymentsList
    internalVariantProps: PlasmicPaymentsList__VariantProps,
    internalArgProps: PlasmicPaymentsList__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicPaymentsList;
/* prettier-ignore-end */
